import { Array as A } from 'effect';

import type { User } from '@/domain/organizationUser/schemas';

export const withDialCodeSeparator = (phone: string) => phone.replace(/^.{3}/, (code) => `${code}-`);

export const getUserDisplayName = ({ first_name, last_name }: Pick<User, 'first_name' | 'last_name'>) => {
  const fullName = `${typeof first_name === 'string' ? `${first_name} ` : ''}${last_name || ''}`;
  return fullName;
};

function descendingComparator<T>(a: T, b: T, sortBy: keyof T) {
  if (b[sortBy] < a[sortBy]) {
    return -1;
  }
  if (b[sortBy] > a[sortBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<T>(order: string, sortBy: keyof T) {
  return order === 'desc'
    ? (a: T, b: T) => descendingComparator(a, b, sortBy)
    : (a: T, b: T) => -descendingComparator(a, b, sortBy);
}

const ROLES_ORDER = ['admin', 'accountant', 'user', 'confidential-user', 'supplier'] as const;

type SortableUser = Pick<User, 'admin' | 'role' | 'display_name'>;

export const sortUsers = <T extends SortableUser>(users: ReadonlyArray<T>): T[] => {
  const byName = [...users].sort((a, b) => a.display_name.localeCompare(b.display_name));
  return A.flatMap(ROLES_ORDER, (group) => A.filter(byName, (user) => (user.admin ? 'admin' : user.role) === group));
};

export const sortCompanies = <T extends { cname: string }>(companies: ReadonlyArray<T>): T[] =>
  [...companies].sort((a, b) => a.cname.localeCompare(b.cname));
